module.exports = __webpack_public_path__ + "img/kbank.0c106c80.png";